import { AxiosError } from 'axios';
import { POST_AUDIT_VIEW_PROFILE_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostAuditViewProfile = ({ onSuccess, onError }: Input = {}) => {
  const postAuditViewProfile = async () => {
    await axiosClient.post(POST_AUDIT_VIEW_PROFILE_URL);
  };

  return useCustomMutation(postAuditViewProfile, {
    onSuccess,
    onError,
  },false,false);
};
